import { InjectionToken } from '@angular/core';
import { GoogleLocalesMapConfigLoader } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const GOOGLE_LOCALES_MAP_CONFIG_LOADER: InjectionToken<GoogleLocalesMapConfigLoader> =
  new InjectionToken<GoogleLocalesMapConfigLoader>('googleLocalesMapConfigLoader');
